import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import service from '@services/passenger-bus'

export const fetchRoutes = createAsyncThunk('routes/fetchRoutes', async (params, { rejectWithValue }) => {
  try { const res = await service.getRoutes(params); return { params, data: res.data, meta: res.meta } } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})

export const fetchRoute = createAsyncThunk('routes/fetchRoute', async (id, { rejectWithValue }) => {
  try { return await service.getRoute(id) } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})

export const addRoute = createAsyncThunk('routes/addRoute', async (payload, { rejectWithValue }) => {
  try { return await service.addRoute(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})

export const saveRoute = createAsyncThunk('routes/saveRoute', async (payload, { rejectWithValue }) => {
  try { return await service.updateRoute(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})

export const removeRoute = createAsyncThunk('routes/removeRoute', async (id, { rejectWithValue }) => {
  try { await service.deleteRoute(id); return id } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})

const slice = createSlice({
  name: 'routes',
  initialState: { data: [], meta: null, params: { page: 1, take: 10, order: 'ASC', q: '' }, selected: null, loading: false, error: null },
  reducers: { setRouteParams(state, action) { state.params = action.payload } },
  extraReducers: b => {
    b.addCase(fetchRoutes.pending, s => { s.loading = true })
     .addCase(fetchRoutes.fulfilled, (s, a) => { s.loading = false; s.data = a.payload.data; s.meta = a.payload.meta; s.params = a.payload.params })
     .addCase(fetchRoutes.rejected, (s, a) => { s.loading = false; s.error = a.payload })
     .addCase(fetchRoute.pending, s => { s.loading = true })
     .addCase(fetchRoute.fulfilled, (s, a) => { s.loading = false; s.selected = a.payload })
     .addCase(fetchRoute.rejected, (s, a) => { s.loading = false; s.error = a.payload })
     .addCase(addRoute.fulfilled, (s, a) => { s.data.unshift(a.payload) })
     .addCase(saveRoute.fulfilled, (s, a) => { const i = s.data.findIndex(x => x.id === a.payload.id); if (i > -1) s.data[i] = a.payload })
     .addCase(removeRoute.fulfilled, (s, a) => { s.data = s.data.filter(x => x.id !== a.payload) })
  }
})

export const { setRouteParams } = slice.actions
export default slice.reducer
